import { useEffect, useMemo } from "react";

import type { components } from "../../api/schema";
import { traceNodeNamesById } from "../../lib/traces";
import type { ListQueryResult } from "../../lib/useListQuery";

type TraceSpansResponse = components["schemas"]["TraceSpansResponse"];

export function useTraceNodeNames(
  traces: TraceSpansResponse[] | undefined,
): Record<string, string> {
  return useMemo(() => {
    const names: Record<string, string> = {};
    for (const trace of traces ?? []) {
      Object.assign(names, traceNodeNamesById(trace.tree));
    }
    return names;
  }, [traces]);
}

// A deep-linked answer span may be on a later trace page. Continue the
// keyset stream until that concrete span appears or the list is exhausted.
export function useTraceSpanPagination(
  activeSpanId: string | undefined,
  traceNodeNames: Record<string, string>,
  traces: ListQueryResult<TraceSpansResponse>,
): void {
  useEffect(() => {
    if (
      activeSpanId !== undefined &&
      traceNodeNames[activeSpanId] === undefined &&
      traces.errorMessage === undefined &&
      traces.hasNextPage &&
      !traces.isFetching
    ) {
      traces.fetchNextPage();
    }
  }, [activeSpanId, traceNodeNames, traces]);
}
